/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgReliabilityDns = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 10.793h-.85v-3.43H8.46v-2.18h.84l.5-.5V2l-.5-.5H6.605l-.5.5v2.683l.5.5h.855v2.18H2.85v3.43H2l-.5.5V14l.5.5h2.697l.5-.5v-2.707l-.5-.5H3.85v-2.43h3.61v2.43h-.855l-.5.5V14l.5.5H9.3l.5-.5v-2.707l-.5-.5h-.84v-2.43h3.692v2.43h-.847l-.5.5V14l.5.5H14l.5-.5v-2.707l-.5-.5zM7.105 2.5H8.8v1.695H7.105V2.5zm-2.908 11H2.5v-1.707h1.695l.002 1.707zm4.603 0H7.105v-1.707H8.8V13.5zm4.7 0h-1.695v-1.707H13.5V13.5z"
}));

export default SvgReliabilityDns;